import { FunctionalComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { Nav } from '@accedo/spatial-nav';
import { setLoadingIndicatorVisibility } from '##/components/LoadingIndicator';
import { nav } from '##/services/navigation';

import styles from './NotFound.module.scss';

const pageId = 'NotFoundPage';

export const NotFoundPage: FunctionalComponent = () => {
  useEffect(() => {
    nav.assignFocus(pageId);
    setLoadingIndicatorVisibility(false);
  }, []);

  return (
    <Nav.Focusable id={pageId}>
      <div className={styles.notFoundPage} id={pageId}>
        <section>
          <h1>404: Not Found</h1>
          <p>It's gone :(</p>
        </section>
      </div>
    </Nav.Focusable>
  );
};
